// extracted by mini-css-extract-plugin
export default {"container":"styles_container__VeYuJ","label":"styles_label__k8WVC","icon":"styles_icon__r9rvW"};